import STATES from './STATES';

const reducers = (state = {}, { type, ...action }) => {
  switch (type) {
    case STATES.OPEN:
      if (state.anchor === action.anchor) {
        return {
          open: false,
        };
      }
      return {
        ...action,
        open: true,
      };

    case STATES.CLOSE:
      return {
        open: false,
      };

    default:
      return state;
  }
};

export default reducers;



// WEBPACK FOOTER //
// ./src/components/stateful/DropDown/reducers.js